import { Component, OnInit, OnChanges, SimpleChanges , ViewChild, TemplateRef, Input,Output,EventEmitter, Injectable} from '@angular/core';
import { IHaloDropDown } from 'src/app/core/halo-dropdown/halo-dropdown.interface';
import { HaloModalSize } from 'src/app/core/halo-modal/halo-modal-interface';
import { HaloModalService } from 'src/app/core/halo-modal/halo-modal.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from 'src/app/core/date-range-picker/ngb-date-parser-formatter';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { StaffService } from 'src/app/post-login/services/staff.service';
import { IStaffResponse } from 'src/app/post-login/services/staff.model';
import { Subscription } from 'rxjs';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
@Component({
  selector: 'app-dismiss-dialog',
  templateUrl: './dismiss-dialog.component.html',
  styleUrls: ['./dismiss-dialog.component.scss']
})

export class DismissDialogComponent implements OnInit {
  @Input() source: string;
  @Input() data: any;
  @Input() openModal: boolean;
  @Output() saveModal = new EventEmitter<object>();
  @Output() closeModal = new EventEmitter<boolean>();
  @ViewChild('titleTemplateComplete') titleTemplateComplete: TemplateRef<any>;
  @ViewChild('bodyTemplateComplete') bodyTemplateComplete: TemplateRef<any>;
  @ViewChild('footerTemplateComplete') footerTemplateComplete: TemplateRef<any>;
  currentFacility: FacilityObject;
  rootScopeData: RootScopeDeclare;
  sub = new Subscription();
  constructor(private _modal: HaloModalService,private _commonUtil: CommonUtil,private _facilityService: FacilityService,private _staffService: StaffService,private _rootScopeService: RootScopeService) {
   }

  ngOnInit(): void {
    this.currentFacility = this._facilityService.selectedFacility();
    const _facilityOnChangeSub = this._facilityService.selectedFacilitySource.subscribe((res) => {
      if(this.currentFacility.facilityId != res.facilityId) {
        this.currentFacility = res;        
      }
    });
    this.sub.add(_facilityOnChangeSub);

    const _rootScopeServiceSub = this._rootScopeService.getRootScope().subscribe((rootScopeData) =>{
      this.rootScopeData = rootScopeData;      
    });
    this.sub.add(_rootScopeServiceSub);
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if(changes.openModal && changes.openModal.currentValue !== changes.openModal.previousValue && changes.openModal.currentValue === true){
      this._modal.add({
        dismissible: true,
        titleUppercase: true,
        modalSize: HaloModalSize.Medium,
        onDismiss: this.onDismiss,
        titleTemplate: this.titleTemplateComplete,     
        bodyTemplate: this.bodyTemplateComplete,
        footerTemplate: this.footerTemplateComplete,
        isVideoTree:false,
      });
    }

    if(changes.openModal && changes.openModal.currentValue !== changes.openModal.previousValue && changes.openModal.currentValue === false){
      this._modal.close();
    }

    if(changes.data && changes.data.currentValue && changes.data.currentValue !== changes.data.previousValue){
      console.log('---data----',changes.data.currentValue);
    }
  }
  
  onSaveClick(){
    if(this.source === "equipmentRotations"){      
      let cmpObj = {
        "action":"dismiss",
        "activityId": Number(this.data.activityId),
        "completedTimestamp":new Date().getTime(),
        "completedUserName": this.rootScopeData.currentUser.emailAddress,
        "facilityId": Number(this.currentFacility.facilityId),
        "highUseEquipmentId": Number(this.data.highUsageEquipment.assetId),
        "lowUseEquipmentId": Number(this.data.lowUsageEquipment.assetId),
        "userEmail": this.rootScopeData.currentUser.emailAddress
      }
      this.saveModal.emit(cmpObj);   
    }else{
      let cmpObj = {
      }
      this.saveModal.emit(cmpObj);   
    }
  }

  onCancelClick(){   
    this._modal.close();  
    this.closeModal.emit(true);  
  }

  onDismiss() {
    //...
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
